export default __webpack_public_path__ + "static/media/approve-status-button.abf5b471.svg";